import { format, subDays } from 'date-fns'
import store from '@/store'

export function isPlainObject (value) {
  return Object.prototype.toString.call(value) === '[object Object]'
}

export function isValidUserId (value) {
  const regType = /^[A-Za-z0-9+]{3,20}$/
  return regType.test(value)
}

export function isValidPassword (value) {
  const regType = /^(?=.*[a-zA-Z0-9!@#$%^&*()_+{}\[\]:;<>,.?~\\/-])[a-zA-Z0-9!@#$%^&*()_+{}\[\]:;<>,.?~\\/-]{4,}$/
  return !/\s/.test(value) && regType.test(value)
}

export function isInteger (value) {
  return typeof value === 'number' && isFinite(value) && Math.floor(value) === value
}
export function deleteCommas (value) {
  const split = value.split(',')
  let returnVal = ''
  for (const item of split) {
    returnVal += item
  }
  if (isNaN(returnVal)) {
    return null
  } else {
    return Number(returnVal)
  }
}
export function upperFirst (value) {
  value = String(value)

  if (!value.length) {
    return value
  }
  return value.charAt(0).toUpperCase() + value.slice(1)
}

export function cloneDeep (data) {
  return JSON.parse(JSON.stringify(data))
}
export function jsonSort (item, ord, type) {
  let _type = 'asc'
  if (type) {
    _type = type
  }
  item.sort((a, b) => {
    if (_type === 'asc') {
      return Number(a[ord]) - Number(b[ord])
    } else if (_type === 'desc') {
      return Number(b[ord]) - Number(a[ord])
    }
  })
  return item
}

export function getPercentage (value, total, digits) {
  if (isNaN(value) || isNaN(total) || total === 0) {
    return 0
  }

  let result = (value / total) * 100

  if (digits !== undefined) {
    result = Number(result.toFixed(digits))
  }
  return result
}

export function getTimeString (value) {
  const hour = Math.floor(value / 3600)
  const minute = Math.floor(value / 60) % 60
  const second = Math.round(value % 60)
  if (hour >= 1) {
    return `${hour}h ${minute}m ${second}s`
  }
  if (minute >= 1) {
    return `${minute}m ${second}s`
  }
  return `${second}s`
}

export function getNumberWithOrdinal (n) {
  const s = ['th', 'st', 'nd', 'rd']
  const v = n % 100
  return n + (s[(v - 20) % 10] || s[v] || s[0])
}

export function thousand (value, fixed = 2) {
  // value = Number(value)
  // return value.toLocaleString('en-US', { minimumFractionDigits: fixed, maximumFractionDigits: fixed })
  const cashDecimal = (store && store.state && store.state.siteOption && store.state.siteOption.cashDecimal) ? store.state.siteOption.cashDecimal : 1
  const cash = typeof value === 'number' ? value * cashDecimal : Number(value) * cashDecimal
  if (cashDecimal === '1' || cashDecimal === 1) {
    fixed = 0
  }
  return cash.toLocaleString('en-US', { minimumFractionDigits: fixed, maximumFractionDigits: fixed })
}

export function thousandCount (value, fixed = 0) {
  value = typeof value === 'number' ? value : Number(value)
  return value.toLocaleString('en-US', { minimumFractionDigits: fixed, maximumFractionDigits: fixed })
}

export function leadingZero (number) {
  return number < 10 ? '0' + number : number
}

export function capitalize (string) {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

export function getDateStr (value, defaultStr) {
  if (!defaultStr) {
    defaultStr = 'yyyy-MM-dd HH:mm:ss'
  }

  return format(value, defaultStr)
}
export function replaceDateT (dateStr) {
  return formatKoreanDateTime(dateStr)
}

// Member login and cashTransLog return KST wall-clock values labelled with Z.
// Use only for those fields; preserve their clock time instead of converting UTC.
export function formatServerClockTime (value) {
  if (value == null || value === '') return '-'
  const text = String(value).trim()
  const match = text.match(/^(\d{4}-\d{2}-\d{2})[T ](\d{2}:\d{2}:\d{2})(?:\.\d+)?(?:Z|[+-]\d{2}:?\d{2})?$/i)
  return match ? `${match[1]} ${match[2]}` : text
}

export function formatKoreanDateTime (value) {
  if (!value) {
    return value
  }

  let date
  if (value instanceof Date) {
    date = value
  } else {
    const dateStr = String(value).trim().replace(' ', 'T')
    if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
      return dateStr
    }
    const hasTimeZone = /(?:Z|[+-]\d{2}:?\d{2})$/i.test(dateStr)
    date = new Date(hasTimeZone ? dateStr : `${dateStr}+09:00`)
  }

  if (isNaN(date.getTime())) {
    return String(value).replace('T', ' ')
  }

  const koreanDate = new Date(date.getTime() + 9 * 60 * 60 * 1000)
  const year = koreanDate.getUTCFullYear()
  const month = String(koreanDate.getUTCMonth() + 1).padStart(2, '0')
  const day = String(koreanDate.getUTCDate()).padStart(2, '0')
  const hour = String(koreanDate.getUTCHours()).padStart(2, '0')
  const minute = String(koreanDate.getUTCMinutes()).padStart(2, '0')
  const second = String(koreanDate.getUTCSeconds()).padStart(2, '0')

  return `${year}-${month}-${day} ${hour}:${minute}:${second}`
}

export function displayDateTime (dateStr, isUTC = false) {
  const value = isUTC && !/(?:Z|[+-]\d{2}:?\d{2})$/i.test(dateStr)
    ? `${dateStr}Z`
    : dateStr
  return formatKoreanDateTime(value).slice(0, 16)
}

export function numberWithCommas (value) {
  return thousand(value)
}
export function getSubDaysDate (value, days) {
  return subDays(value, days)
}
export function onlyNumber (e) {
  const val = e.target.value
  e.target.value = val.replace(/[^0-9]/g, '')
  e.target.value = numberWithCommas(e.target.value)
}

export function timeConverter_seconds (seconds) {
  let timeType = ''
  if (seconds >= 60) {
    timeType = 'minutes'
  } else if (seconds >= 3600) {
    timeType = 'hours'
  } else {
    timeType = 'seconds'
  }

  let converTime = ''
  let HH = ''
  let MM = ''
  let SS = ''
  switch (timeType) {
    case 'seconds':
      converTime = ''
      break
    case 'minutes':
      MM = Math.floor(seconds / 60)
      SS = seconds - MM * 60

      converTime = `00:${MM}:${SS}`
      break
    case 'hours':
      HH = Math.floor(seconds / 3600)
      MM = Math.floor(seconds / 60)
      SS = seconds - MM * 60

      converTime = `${HH}:${MM}:${SS}`
      break
  }

  return converTime
}

let stopCount = 0
export function stopedInterval (item) {
  clearInterval(item)
  stopCount++
}

function b64DecodeUnicode (str) {
  return decodeURIComponent(
    Array.prototype.map.call(atob(str), c =>
      '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
    ).join(''))
}

export function parseJwt (token) {
  return JSON.parse(
    b64DecodeUnicode(
      token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')
    )
  )
}
